import { useTranslation } from 'react-i18next';

const languages = [
    { code: 'nl', label: 'NL' },
    { code: 'de', label: 'DE' },
    { code: 'en', label: 'EN' },
    { code: 'fr', label: 'FR' },
];

export default function LanguageSwitcher() {
    const { i18n } = useTranslation();

    const handleChange = (lang) => {
        i18n.changeLanguage(lang);
        localStorage.setItem('ast_locale', lang);
    };

    return (
        <div className="ast-lang-switcher">
            {languages.map((lang) => (
                <button
                    key={lang.code}
                    className={`ast-lang-switcher__btn ${i18n.language === lang.code ? 'ast-lang-switcher__btn--active' : ''}`}
                    onClick={() => handleChange(lang.code)}
                >
                    {lang.label}
                </button>
            ))}
        </div>
    );
}
